import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StoreService, SessionStorageKeys } from 'src/app/core/services/store.service';

@Injectable()
export class HttpUserSessionInterceptor implements HttpInterceptor {

    constructor(private store: StoreService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const sessionId = this.store.getSession<string>(SessionStorageKeys.SESSION_ID);
        
        if (sessionId) {
            request = request.clone({
                headers: request.headers.set('X-Session-ID', sessionId)
            });
        }else{
            console.error("Session-ID is missing from the session store. Contact support.")
        }

        return next.handle(request);
    }
}